theme.Currency = (function () {
  var moneyFormat = "${{amount}}";

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();
function onAnimationEnd(elements, callback, options = { subtree: true }) {
  const animations = Array.isArray(elements)
    ? elements.flatMap((element) => element.getAnimations(options))
    : elements.getAnimations(options);
  const animationPromises = animations.reduce((acc, animation) => {
    if (animation.timeline instanceof DocumentTimeline) {
      acc.push(animation.finished);
    }

    return acc;
  }, []);

  return Promise.allSettled(animationPromises).then(callback);
}
window.theme = window.theme || {};
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.section_wrapper = this.closest("header");
    this.outer_wrapper = this.closest(".site-header__outer");
    this.navigation = this.querySelector(".main-navigation__inner");
    this.padding =
      parseInt(window.getComputedStyle(this).getPropertyValue("padding-left").replace("px", "")) *
      2;

    this.navigation_items = Array.from(this.navigation.children);

    this.header_min_width = this.navigation_items.reduce((acc, item) => {
      const item_width =
        window.getComputedStyle(item).getPropertyValue("padding-left").replace("px", "") * 2 +
        item.scrollWidth;
      return (acc += item_width);
    }, 0);
    this.header_min_width = this.header_min_width + (this.navigation_items.length - 1) * 30;
  }

  connectedCallback() {
    this.addEventListeners();
    this.collapseNavigation();
  }

  addEventListeners() {
    window.addEventListener("scroll", this.stickyNavigation.bind(this));
    window.addEventListener("resize", this.collapseNavigation.bind(this));
    window.addEventListener("DOMContentLoaded", this.collapseNavigation.bind(this));
  }

  stickyNavigation() {
    const wrapper = this.section_wrapper.getBoundingClientRect();
    if (window.scrollY > wrapper.top) {
      this.outer_wrapper.classList.add("site-header__sticky");
    } else {
      this.outer_wrapper.classList.remove("site-header__sticky");
    }
  }

  collapseNavigation() {
    if (document.documentElement.clientWidth - this.padding < this.header_min_width) {
      this.outer_wrapper.classList.add("site-header__collapse");
    } else {
      this.outer_wrapper.classList.remove("site-header__collapse");
    }
  }
}

customElements.define("site-header", SiteHeader);

class DrawerElement extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    this.drawer = this.querySelector("details");
    this.drawer_body = this.querySelector("[target-drawer-content]");
    this.main_button = this.querySelector("[action-open-drawer]");
    this.events = [
      {
        el: this,
        evt: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: document,
        evt: "click",
        callback: this.outsideClickHandler.bind(this),
      },
      {
        el: this,
        evt: "keydown",
        callback: this.keyboardHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.handleEventListeners();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  clickHandler(e) {
    if (e.target.closest("[action-open-drawer]")) {
      e.preventDefault();
      this.toggleMenu();
    }
    if (e.target.closest("[action-close-drawer]")) {
      this.setHidden();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest(".drawer") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (!this.is_open) {
      this.setVisible();
    } else {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.main_button.setAttribute("aria-expanded", "false");
    this.classList.remove("drawer-open");
    this.drawer.removeAttribute("open");
  }

  setVisible() {
    this.drawer.setAttribute("open", "");
    this.is_open = true;
    this.main_button.setAttribute("aria-expanded", "true");
    this.classList.add("drawer-open");
  }
}

customElements.define("drawer-element", DrawerElement);

class NavigationMenuDrawer extends DrawerElement {
  constructor() {
    super();
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.closest(".menu-drawer__button[aria-expanded]")) {
      this.toggleSubMenu(e);
    }
  }

  keyboardHandler(e) {
    super.keyboardHandler(e);
    if (e.code === "Space") {
      if (e.target.classList.contains("menu-drawer__button")) {
        this.toggleSubMenu(e.target);
      }
    }
  }

  checkFocus() {
    const activeLink = document.activeElement;
    const parent = activeLink.closest(".menu-drawer__parent-item");
    if (!parent || parent !== this.activeParent) {
      this.closeAllMenus();
    }
    if (parent && parent.querySelector('[aria-expanded="false"]')) {
      this.openSubMenu(parent.querySelector('[aria-expanded="false"]'));
      this.activeParent = parent;
    }
  }

  toggleSubMenu(e) {
    const target = e.target.closest(".menu-drawer__button[aria-expanded]");
    if (target.getAttribute("aria-expanded") === "false") {
      this.openSubMenu(target);
    } else {
      this.closeSubMenu(target);
    }
  }

  openSubMenu(target) {
    target.setAttribute("aria-expanded", true);
    const menu = target.nextElementSibling;
    menu.style.height = "auto";
  }

  closeSubMenu(target) {
    target.setAttribute("aria-expanded", false);
    const menu = target.nextElementSibling;
    menu.style.height = "0px";
  }

  closeAllMenus() {
    this.querySelectorAll(".menu-drawer__button[aria-expanded]").forEach((menu) => {
      this.closeSubMenu(menu);
    });
  }

  setHidden() {
    super.setHidden();
    this.closeAllMenus();
  }
}
customElements.define("navigation-menu-drawer", NavigationMenuDrawer);

class MainNavigation extends HTMLElement {
  constructor() {
    super();

    this.parents = this.querySelectorAll(".main-navigation__parent-item");
    this.is_touch = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
    this.events = [
      {
        el: this,
        evt: "keydown",
        callback: this.keyboardHandler.bind(this),
      },
    ];

    for (const parent of this.parents) {
      if (this.is_touch) {
        this.events.push({
          el: parent,
          evt: "click",
          callback: this.clickHandler.bind(this),
        });
      } else {
        this.events.push(
          {
            el: parent,
            evt: "mouseenter",
            callback: this.mouseHandler.bind(this),
          },
          {
            el: parent,
            evt: "mouseleave",
            callback: this.mouseHandler.bind(this),
          },
        );
      }
    }

    if (this.is_touch) {
      this.events.push({
        el: document,
        evt: "click",
        callback: this.outsideClickHandler.bind(this),
      });
    }
  }

  connectedCallback() {
    this.handleEventListeners();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  clickHandler(e) {
    if (
      e.target.classList.contains("main-navigation__parent-button") &&
      e.target.getAttribute("aria-expanded") === "false"
    ) {
      e.preventDefault();
      this.closeAllMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("main-navigation") !== this) {
      this.closeAllMenus();
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseleave") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    } else if (e.type === "mouseenter") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true");
    }
  }

  openMenu(target) {
    if (this.activeParent !== target) {
      // Close the active menu before opening the next
      this.activeParent?.setAttribute("aria-expanded", false);

      target.setAttribute("aria-expanded", true);
      this.activeParent = target;
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded") === "false") {
        e.preventDefault();
        this.closeAllMenus();
        e.target.setAttribute("aria-expanded", "true");
      } else {
        e.target.setAttribute("aria-expanded", "false");
      }
    }
    if (e.key === "Escape") {
      this.parents.forEach((parent) => {
        parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      });
    }
  }

  closeAllMenus() {
    this.parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("main-navigation", MainNavigation);

class DialogModal extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    this.dialog = this.querySelector("details");
    this.dialog_body = this.querySelector("[target-dialog-content]");
    this.main_button = this.querySelector("[action-open-dialog]");
    this.window_width = window.innerWidth;
    this.events = [
      {
        el: this,
        evt: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: document,
        evt: "click",
        callback: this.outsideClickHandler.bind(this),
      },
      {
        el: window,
        evt: "resize",
        callback: this.resizeHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    if (window.innerWidth < 768) {
      this.dialog.open = false;
      this.classList.add("modal-ready");
    }
    this.handleEventListeners();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  clickHandler(e) {
    if (e.target.closest("[action-open-dialog]")) {
      e.preventDefault();
      this.toggleDialog();
    }
    if (e.target.closest("[action-close-dialog]")) {
      this.setHidden();
    }
  }

  outsideClickHandler(e) {
    if (!this.contains(e.target) && this.is_open) {
      e.preventDefault();
      this.setHidden();
    }
  }
  resizeHandler(e) {
    if (window.innerWidth > 767) {
      this.dialog.open = true;
    } else {
      if (this.window_width === window.innerWidth) return;
      this.dialog.open = false;
      this.classList.add("modal-ready");
    }
  }

  toggleDialog() {
    if (!this.is_open) {
      this.setVisible();
    } else {
      this.setHidden();
    }
  }

  setHidden() {
    this.main_button.setAttribute("aria-expanded", "false");
    this.classList.remove("dialog-open");
    onAnimationEnd(this.dialog_body, () => {
      this.is_open = false;
      this.dialog.open = false;
    });
  }

  setVisible() {
    this.dialog.open = true;
    this.is_open = true;
    this.main_button.setAttribute("aria-expanded", "true");
    this.classList.add("dialog-open");
    if (this.querySelector("main-predictive-search")) {
      const temporary_input = document.createElement("input");
      temporary_input.setAttribute("type", "text");
      temporary_input.style.position = "absolute";
      temporary_input.style.opacity = 0;
      temporary_input.style.height = 0;
      temporary_input.style.fontSize = "16px";
      temporary_input.setAttribute("readonly", true);
      document.body.prepend(temporary_input);
      temporary_input.focus();
      setTimeout(() => {
        const search_input = this.querySelector("main-predictive-search input");
        search_input.focus();
        temporary_input.remove();
        search_input.dispatchEvent(new Event("focus"));
      }, 100);
    }
  }
}

customElements.define("dialog-modal", DialogModal);

class MainPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.is_active = false;
    this.search = {
      query: this.getAttribute("search-query"),
      type: this.dataset.searchType || "product,query,collection",
      limit: this.dataset.maxResults || "10",
      scope: "each",
      fields:
        this.dataset.searchFields ||
        "title,product_type,variants.title,variants.sku,variants.barcode,tag",
      unavailable: this.dataset.unavailableProducts || "last",
    };
    this.results = this.querySelector("#main-predictive-search-results");
    this.input_wrapper = this.querySelector(".input-wrapper");
    this.input = this.querySelector('input[type="search"]');

    this.events = [
      {
        evt: "click",
        el: this,
        callback: this.clickHandler.bind(this),
      },
      {
        evt: "click",
        el: document,
        callback: this.outsideClickHandler.bind(this),
      },
      {
        evt: "input",
        el: this.input,
        callback: this.debounce((event) => {
          this.inputHandler(event);
        }, 300).bind(this),
      },
    ];
  }

  connectedCallback() {
    this.handleEventListeners();
    this.setResultsMaxHeight();
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  clickHandler(e) {
    if (e.target.classList.contains("input-clear")) {
      this.input.value = "";
      this.input.dispatchEvent(new Event("input"));
      this.input.focus();
    }
    if (e.target.closest("[data-search-action]")?.dataset.searchAction === "close") {
      this.closeResultsPane();
    }
  }
  outsideClickHandler(e) {
    if (!this.contains(e.target)) {
      this.closeResultsPane();
    }
  }

  attributeChangedCallback(name, prev, next) {
    if (prev === next) return;
    if (next === "") {
      this.closeResultsPane();
      this.results.innerHTML = "";
      return;
    }

    this.getNewSearch();
  }

  static get observedAttributes() {
    return ["search-query"];
  }

  inputHandler() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.setAttribute("search-query", query);
  }

  async getNewSearch() {
    this.loading_el = this.querySelector(".main-predictive-search__loading");
    this.loading_el ? this.loading_el.setAttribute("aria-hidden", "false") : null;
    const string = `/search/suggest?q=${this.search.query}&resources[type]=${this.search.type}&resources[limit]=${this.search.limit}&resources[limit_scope]=${this.search.scope}&resources[options][fields]=${this.search.fields}&resources[options][unavailable_products]=${this.search.unavailable}&section_id=predictive-search`;
    try {
      const response = await fetch(string);
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.text();
      const markup = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector("#shopify-section-predictive-search").innerHTML;
      this.results.innerHTML = markup;
      this.openResultsPane();
    } catch (error) {
      this.closeResultsPane();
    }
    this.loading_el ? this.loading_el.setAttribute("aria-hidden", "false") : null;
  }

  setResultsMaxHeight() {
    this.results.removeAttribute("style");
    const results_rect = this.results.getBoundingClientRect();
    if (this.results.scrollHeight + results_rect.top + 20 > window.innerHeight) {
      this.results.style.height = window.innerHeight - 20 - results_rect.top + "px"; // remove an extra 20px from height to space from bottom of browser window
    }
  }

  openResultsPane() {
    this.setResultsMaxHeight();
    if (this.results.innerHTML !== "") {
      this.results.classList.add("main-predictive-search-results--visible");
    }
  }

  closeResultsPane() {
    this.results.removeAttribute("style");
    this.results.classList.remove("main-predictive-search-results--visible");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("main-predictive-search", MainPredictiveSearch);

class BasketBuilder extends HTMLElement {
  constructor() {
    super();

    this.events = [];
    this.rewards = this.dataset.rewards?.split("|||");
    this.thresholds = this.dataset.thresholds?.split("|||");
    this.messages = this.dataset.messages?.split("|||");
    this.cartUpdate = this.cartUpdate.bind(this);
  }
  // cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.handleEventListeners("add");
    // this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    //   this.updateShippingBar(event.cartData);
    // });

    window.addEventListener("cart:updated", this.cartUpdate);
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
    // if (this.cartUpdateUnsubscriber) {
    //   this.cartUpdateUnsubscriber();
    // }
    window.removeEventListener("cart:updated", this.cartUpdate);
  }

  async getCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }

      const cart = await response.json();
      return cart;
    } catch (error) {
      console.log("Error in getCart:", error);
      return null;
    }
  }

  async cartUpdate() {
    const cart = await this.getCart();
    if (cart) {
      this.updateShippingBar(cart);
      if (cart.item_count <= 0) {
        this.classList.add("hidden");
      } else {
        this.classList.remove("hidden");
      }
    }
  }

  handleEventListeners(type) {
    for (const evt of this.events) {
      if (type === "add") {
        evt.el.addEventListener(evt.type, evt.callback);
      } else {
        evt.el.removeEventListener(evt.type, evt.callback);
      }
    }
  }
  updateShippingBar(data) {
    this.updateProgress(data.total_price);
    this.updateMessage(data.total_price);
  }
  updateProgress(price) {
    const max_threshold = +this.thresholds[this.thresholds.length - 1] * 100;
    const percent = Math.min((price / max_threshold) * 100, 100);
    this.querySelector(".progress__inner").style.width = `${percent}%`;
  }
  updateMessage(price) {
    this.querySelectorAll(`[data-tier]`).forEach((tier) => tier.classList.remove("tier--active"));
    const messages = { ...this.messages };

    const message_container = this.querySelector(".basket-builder__message");

    const completed_tiers = this.thresholds.filter((tier) => {
      return +tier * 100 <= price;
    });
    const current_tier = this.thresholds.filter((tier) => {
      return +tier * 100 > price;
    });

    for (const [index, tier] of completed_tiers.entries()) {
      this.querySelector(`[data-tier="${index + 1}"]`).classList.add("tier--active");
    }

    if (completed_tiers.length === this.thresholds.length) {
      message_container.innerHTML = this.dataset.complete.replace(
        "[[reward]]",
        this.rewards[this.rewards.length - 1],
      );
    } else {
      messages[completed_tiers.length] = messages[completed_tiers.length]
        .replace(
          "[[remaining]]",
          Shopify.formatMoney(+current_tier[0] * 100 - price, theme.moneyFormat),
        )
        .replace("[[reward]]", this.rewards[completed_tiers.length]);

      message_container.innerHTML = messages[completed_tiers.length];
    }
  }
}
customElements.define("basket-builder", BasketBuilder);
if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia("(min-width: 750px)");
        this.header = document.querySelector(".header-wrapper");
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector("button.localization-form__select"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector(".country-selector__close-button"),
          resetButton: this.querySelector(".country-filter__reset-button"),
          searchIcon: this.querySelector(".country-filter__search-icon"),
          liveRegion: this.querySelector("#sr-country-search-results"),
        };
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
        this.addEventListener("keydown", this.onContainerKeyDown.bind(this));
        this.addEventListener("focusout", this.closeSelector.bind(this));
        this.elements.button.addEventListener("click", this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener("keyup", this.filterCountries.bind(this));
          this.elements.search.addEventListener("focus", this.onSearchFocus.bind(this));
          this.elements.search.addEventListener("blur", this.onSearchBlur.bind(this));
          this.elements.search.addEventListener("keydown", this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener("click", this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener("click", this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener("mousedown", (event) =>
            event.preventDefault(),
          );
        }

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this)),
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
        if (this.elements.search) {
          this.elements.search.value = "";
          this.filterCountries();
          this.elements.search.setAttribute("aria-activedescendant", "");
        }
        document.body.classList.remove("overflow-hidden-mobile");
        document.querySelector(".menu-drawer").classList.remove("country-selector-open");
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll("a")).filter(
          (item) => !item.parentElement.classList.contains("hidden"),
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case "ARROWUP":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0
                ? focusableItems[focusedItemIndex - 1]
                : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case "ARROWDOWN":
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1
                ? focusableItems[focusedItemIndex + 1]
                : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute(
              "aria-activedescendant",
              focusableItems[focusedItemIndex].id,
            );
          } else {
            this.elements.search.setAttribute("aria-activedescendant", "");
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case "ESCAPE":
            if (this.elements.button.getAttribute("aria-expanded") == "false") return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case "SPACE":
            if (this.elements.button.getAttribute("aria-expanded") == "true") return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (this.elements.button.getAttribute("aria-expanded") === "false").toString(),
        );
        if (!document.body.classList.contains("overflow-hidden-tablet")) {
          document.body.classList.add("overflow-hidden-mobile");
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute("data-prevent-hide")) {
          this.header.preventHide = true;
        }
        document.querySelector(".menu-drawer").classList.add("country-selector-open");
      }

      closeSelector(event) {
        if (
          event.target.classList.contains("country-selector__overlay") ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector(".popular-countries");
        const allCountries = this.querySelectorAll("a");
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle("hidden", !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle("hidden", searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector(".country").textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove("hidden");
            visibleCountries++;
          } else {
            item.parentElement.classList.add("hidden");
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.countrySelectorSearchCount.replace(
              "[count]",
              visibleCountries,
            );
        }

        this.querySelector(".country-selector").scrollTop = 0;
        this.querySelector(".country-selector__list").scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = "";
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add("country-filter__search-icon--hidden");
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove("country-filter__search-icon--hidden");
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === "ENTER") {
          event.preventDefault();
        }
      }
    },
  );
}

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.delay_load =
      this.getAttribute("data-load-delay") && this.getAttribute("data-load-delay") === "true"
        ? true
        : false;

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.delay_load) {
      this.init();
    } else {
      document.addEventListener("DOMContentLoaded", this.init.bind(this));
    }
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);

    if (this.classList.contains("main-product__color-carousel-wrapper")) {
      this.initSelectedSlideSync();
    }

    this.dispatchEvent(
      new CustomEvent("swiper:init", {
        detail: {
          swiper: this.swiper,
        },
        bubbles: true,
      }),
    );
  }

  initSelectedSlideSync() {
    this.selectedSlideObserver = new MutationObserver((mutations) => {
      const selectedSlideChanged = mutations.some(({ target, oldValue }) => {
        const wasSelected = oldValue?.split(/\s+/).includes("is--selected");

        return (
          target instanceof Element && target.matches(".swiper-slide.is--selected") && !wasSelected
        );
      });

      if (selectedSlideChanged) {
        requestAnimationFrame(() => this.showSelectedSlide());
      }
    });

    this.selectedSlideObserver.observe(this.elements.swiper, {
      attributes: true,
      attributeFilter: ["class"],
      attributeOldValue: true,
      subtree: true,
    });

    this.showSelectedSlide();
  }

  showSelectedSlide() {
    const selectedSlide = this.elements.swiper.querySelector(".swiper-slide.is--selected");
    if (!selectedSlide) return;

    const carouselBounds = this.elements.swiper.getBoundingClientRect();
    const selectedSlideBounds = selectedSlide.getBoundingClientRect();
    const isVisible =
      selectedSlideBounds.right > carouselBounds.left &&
      selectedSlideBounds.left < carouselBounds.right;

    if (isVisible) return;

    const selectedIndex = this.swiper.slides.indexOf(selectedSlide);
    if (selectedIndex < 0) return;

    this.swiper.slideTo(selectedIndex, 300);
  }

  disconnectedCallback() {
    this.selectedSlideObserver?.disconnect();
  }
}
customElements.define("main-carousel", MainCarousel);

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.mouseDown = false;
    this.startX = 0;
    this.handle = null;
    this.minHandle = null;
    this.maxHandle = null;
  }

  addEventListeners() {
    this.addEventListener("mousemove", this.dragHandler.bind(this));
    this.addEventListener("touchmove", this.dragHandler.bind(this));

    this.addEventListener("mousedown", this.startHandler.bind(this));
    this.addEventListener("touchstart", this.startHandler.bind(this));

    this.addEventListener("mouseup", this.endHandler.bind(this));
    this.addEventListener("touchend", this.endHandler.bind(this));
    this.addEventListener("mouseleave", this.endHandler.bind(this));

    document.addEventListener("range:set", this.setHandlePositions.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("mousemove", this.dragHandler.bind(this));
    this.removeEventListener("touchmove", this.dragHandler.bind(this));

    this.removeEventListener("mousedown", this.startHandler.bind(this));
    this.removeEventListener("touchstart", this.startHandler.bind(this));

    this.removeEventListener("mouseup", this.endHandler.bind(this));
    this.removeEventListener("touchend", this.endHandler.bind(this));
    this.removeEventListener("mouseleave", this.endHandler.bind(this));

    document.removeEventListener("range:set", this.setHandlePositions.bind(this));
  }

  connectedCallback() {
    this.minHandle = this.querySelector("#range-slider-min");
    this.maxHandle = this.querySelector("#range-slider-max");
    this.handleWidth = this.minHandle.offsetWidth;
    this.trackSize = this.offsetWidth - this.handleWidth;
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  dragHandler(e) {
    if (!this.mouseDown) return;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    const x =
      pageX -
      (this.getBoundingClientRect().left + e.currentTarget.offsetLeft - this.handleWidth / 2);
    let percentage = 0;
    if (this.handle.id === "range-slider-min" && x < this.handleWidth / 2) {
      this.handle.style.left = `${this.handleWidth / 2}px`;
      percentage = 0;
    } else if (
      this.handle.id === "range-slider-max" &&
      x > this.offsetWidth - this.handleWidth / 2
    ) {
      this.handle.style.left = `${this.offsetWidth - this.handleWidth / 2}px`;
      percentage = 100;
    } else {
      if (
        this.handle.id === "range-slider-min" &&
        x >= this.maxHandle.offsetLeft - this.handleWidth / 2
      ) {
        this.handle.style.left = `${this.maxHandle.offsetLeft - this.handleWidth / 2}px`;
      } else if (
        this.handle.id === "range-slider-max" &&
        x <= this.minHandle.offsetLeft + this.handleWidth * 1.5
      ) {
        this.handle.style.left = `${this.minHandle.offsetLeft + this.handleWidth * 1.5}px`;
      } else {
        this.handle.style.left = `${x}px`;
      }
      percentage = (this.handle.offsetLeft / this.trackSize) * 100;
    }

    // event to update the min and max values as percentages
    this.sendUpdatedHandleValue(this.handle.id, percentage);
  }

  startHandler(e) {
    if (!e.target.classList.contains("range-slider__handle")) return;

    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    this.mouseDown = true;
    this.startX =
      pageX -
      (this.getBoundingClientRect().left + e.currentTarget.offsetLeft - this.handleWidth / 2);
    this.handle = e.target;
  }

  endHandler(e) {
    if (this.mouseDown) {
      const event = new CustomEvent("range:complete");
      document.dispatchEvent(event);
    }
    this.mouseDown = false;
  }

  setHandlePositions(e) {
    const {
      detail: { min, max },
    } = e;

    const maxPosition = (max.current / max.limit) * 100;
    const minPosition = (min.current / max.limit) * 100;

    this.maxHandle.style.left = `${(this.trackSize / 100) * maxPosition + this.handleWidth / 2}px`;
    this.minHandle.style.left = `${(this.trackSize / 100) * minPosition + this.handleWidth / 2}px`;
  }

  sendUpdatedHandleValue(id, percentage) {
    const event = new CustomEvent("range:update", {
      detail: {
        id,
        percentage,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("range-slider", RangeSlider);

class ResultsGrid extends HTMLElement {
  constructor() {
    super();
    this.layout = localStorage.getItem("layout") || "1";
    this.setAttribute("data-layout", this.layout);

    this.showCount = this.getAttribute("count-active") === "true" ? true : false;
    this.showSorting = this.getAttribute("sorting-active") === "true" ? true : false;
    this.showFilters = this.getAttribute("filters-active") === "true" ? true : false;
    this.cards = this.querySelectorAll("product-card");
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("results:refresh:start", this.changeHandler.bind(this));
    window.addEventListener("popstate", () => {
      window.location.reload();
    });
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("results:refresh:start", this.changeHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".main-pagination__wrapper")) {
      this.paginationClick(e);
      return;
    }
    if (e.target.dataset.clear && e.target.closest(".results-grid__empty")) {
      const event = new CustomEvent("filters:clear", {
        detail: {
          changeFilter: e.target,
        },
      });
      document.dispatchEvent(event);
    }
    if (e.target.classList.contains("results-grid__layout-button")) {
      if (this.layout === e.target.dataset.layout) return;
      if (!document.startViewTransition) {
        this.setAttribute("data-layout", this.layout);
        return;
      }

      for (const card of this.cards) {
        card.style.viewTransitionName = `pid--${card.dataset.productId}`;
      }
      document.startViewTransition(() => this.setAttribute("data-layout", this.layout));
      setTimeout(() => {
        for (const card of this.cards) {
          card.removeAttribute("style");
        }
      }, 200);
      this.layout = e.target.dataset.layout;
      localStorage.setItem("layout", this.layout);
    }
  }

  changeHandler(e) {
    this.createSearchString(e);
  }

  connectedCallback() {
    this.classList.add("grid-ready");
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  paginationClick(e) {
    e.preventDefault();
    const link = e.target.closest("a");
    const url = link?.href;
    if (!url) return;
    const paginationUrl = new URL(url);
    const filteredParams = Array.from(paginationUrl.searchParams.entries()).filter((param) => {
      return param[0].indexOf("page") === 0;
    });
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: new URLSearchParams(filteredParams),
        type: "page",
      },
    });
    document.dispatchEvent(event);
  }

  createSearchString(e) {
    const type = e.detail.type;
    const currentSearchParams = Array.from(new URLSearchParams(window.location.search).entries());
    const newSearchParams = new URLSearchParams(e.detail.params);
    const filteredParams = currentSearchParams.filter((param) => {
      if (type !== "page") {
        return param[0].indexOf(type) === -1 && param[0].indexOf("page") === -1;
      } else {
        return param[0].indexOf(type) === -1;
      }
    });
    const searchString = new URLSearchParams([...filteredParams, ...newSearchParams]).toString();
    this.refreshResults(`${window.location.pathname}?${searchString}`);
  }

  updateHistory(url) {
    const currentUrl = new URL(`${window.location.origin}${url}`);
    history.pushState(null, null, currentUrl);
  }

  getStickyHeaderOffset() {
    const headerSelectors = [
      ".site-header",
      ".shopify-section-header-sticky",
      ".t4s-section-header.shopify-section-header-sticky",
    ];
    const headerBottom = headerSelectors.reduce((offset, selector) => {
      const header = document.querySelector(selector);
      if (!header) return offset;

      const styles = window.getComputedStyle(header);
      if (styles.display === "none" || styles.visibility === "hidden") return offset;

      const rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 1) return offset;

      return Math.max(offset, rect.bottom);
    }, 0);

    return Math.ceil(headerBottom);
  }

  scrollToGridTop() {
    const gridTop = this.getBoundingClientRect().top + window.scrollY;
    const scrollTop = Math.max(gridTop - this.getStickyHeaderOffset(), 0);
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: scrollTop,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  }

  async refreshResults(url) {
    this.classList.add("results-grid--loading");
    this.scrollToGridTop();
    try {
      const response = await fetch(`${url}`);
      const data = await response.text();
      const dataHtml = document.createElement("div");
      dataHtml.innerHTML = data;

      const products = dataHtml.querySelector(".results-grid__products");
      const pagination = dataHtml.querySelector(".results-grid__pagination");

      const productElement = this.querySelector(".results-grid__products");
      const paginationElement = this.querySelector(".results-grid__pagination");

      productElement.innerHTML = products.innerHTML;
      paginationElement.innerHTML = pagination.innerHTML;

      if (this.showCount) {
        const productsCount = dataHtml.querySelector(".results-grid__count");
        const productsCountElement = this.querySelector(".results-grid__count");
        productsCountElement.innerHTML = productsCount.innerHTML;
      }
      if (this.showFilters) {
        const dataFiltersElem = dataHtml.querySelector(".results-grid__filters");
        const currentFiltersElem = this.querySelector(".results-grid__filters");

        if (
          !dataFiltersElem.classList.contains("results-grid__filters--hide") &&
          currentFiltersElem.classList.contains("results-grid__filters--hide")
        ) {
          // if refreshed doesnt have hide class and current page has hide, indicates a matching search so insert filters
          currentFiltersElem.innerHTML = dataFiltersElem.innerHTML;
          currentFiltersElem.classList.remove("results-grid__filters--hide");
        }
        if (!currentFiltersElem.classList.contains("results-grid__filters--hide")) {
          const filters = dataHtml.querySelector(
            ".results-grid__filters .results-filters__form .form__content",
          ).outerHTML;
          const mobileButtonCount = dataHtml.querySelector(".results-filters__footer-buttons");
          const mobileButtonCountElement = this.querySelector(".results-filters__footer-buttons");
          productElement.classList.remove("results-grid__products--full");
          mobileButtonCountElement.innerHTML = mobileButtonCount.innerHTML;

          const event = new CustomEvent("results:refresh:success", {
            detail: {
              filter_data: filters,
            },
          });
          document.dispatchEvent(event);
        }
      }

      this.updateHistory(url);
    } catch (error) {
      console.log(error);
    } finally {
      this.classList.remove("results-grid--loading");
      this.cards = this.querySelectorAll("product-card");
    }
  }

  changeLayout(e) {
    if (e.target.dataset.layout === "1") {
      this.querySelector(".results-grid__products").classList.remove("alternate-layout");
    } else {
      this.querySelector(".results-grid__products").classList.add("alternate-layout");
    }
  }
}

customElements.define("results-grid", ResultsGrid);

class ResultsFilters extends HTMLElement {
  constructor() {
    super();
    this.orientation =
      this.closest("results-grid").getAttribute("filter-orientation") || "vertical";
  }

  connectedCallback() {
    this.addEventListeners();
    this.windowWidth = 0;
    this.detectDevice();

    if (!this.querySelector(".price__range")) return;

    this.minPriceElem = this.querySelector('.price__range-from input[type="number"]');
    this.maxPriceElem = this.querySelector('.price__range-to input[type="number"]');
    this.minPrice = parseInt(this.minPriceElem.getAttribute("min"));
    this.maxPrice = parseInt(this.maxPriceElem.getAttribute("max"));

    this.setRangeHandles();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  detectDevice() {
    if (window.innerWidth !== this.windowWidth) {
      if (window.innerWidth <= 768) {
        this.setAttribute("aria-expanded", "false");
        this.resetDrawerState();
      } else {
        this.setAttribute("aria-expanded", "true");
      }
      this.windowWidth = window.innerWidth;
    }
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    if (this.orientation === "horizontal") {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }
    window.addEventListener("resize", this.detectDevice.bind(this));
    document.addEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.addEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.addEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.addEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.addEventListener('input', this.inputHandler.bind(this));
    // document.addEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    window.removeEventListener("resize", this.detectDevice.bind(this));
    document.removeEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.removeEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.removeEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.removeEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.removeEventListener('input', this.inputHandler.bind(this));
    // document.removeEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  clickHandler(e) {
    if (e.detail?.changeFilter || e.target.dataset.filter || e.target.dataset.clear) {
      const target = e.detail.changeFilter ? e.detail.changeFilter : e.target;
      if (target.dataset.active) {
        e.preventDefault();
        // uncheck if active filter is clicked
        if (target.dataset.filter !== "price") {
          this.querySelector(
            `[type="checkbox"][data-filter="${target.dataset.filter}"][value="${target.dataset.value.replaceAll('"', '\\\"')}"]`,
          ).checked = false;
        } else {
          this.querySelectorAll(`[type="number"]`).forEach((filter) => {
            filter.value = "";
            filter.setAttribute("name", "");
          });
        }
      }
      if (target.dataset.clear) {
        e.preventDefault();
        this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
          filter.checked = false;
        });
        this.querySelectorAll(`[type="number"]`).forEach((filter) => {
          filter.value = "";
          filter.setAttribute("name", "");
        });
      }
      this.checkPriceFilters();
      this.debounce(() => this.changeFilter());
      return;
    }
    if (e.target.closest(".btn-elem--price")) {
      e.preventDefault();
      this.applyPriceRange();
    }
    if (e.target.classList.contains("filter__header") || e.target.closest(".filter-option__back")) {
      if (this.orientation === "horizontal") {
        if (e.target.closest(".filter") != this.current_open_filter) {
          this.querySelectorAll(".filter__header").forEach((header) => {
            header.setAttribute("aria-expanded", "false");
          });
        }
      }
      // toggle filter list dropdown
      const target = e.target.closest(".filter").querySelector(".filter__header");
      const toggle = target.ariaExpanded === "true" ? true : false;
      this.current_open_filter = target.closest(".filter");
      target.ariaExpanded = !toggle;
      return;
    }
    if (e.target.classList.contains("filter__more")) {
      e.preventDefault();
      const toggle = e.target.ariaExpanded === "true" ? true : false;
      e.target.ariaExpanded = !toggle;
      e.target.textContent === theme.strings.show_more
        ? (e.target.textContent = theme.strings.show_less)
        : (e.target.textContent = theme.strings.show_more);
      return;
    }
    if (e.target.dataset.action === "open-filter-drawer") {
      this.openFilterDrawer();
      return;
    }
    if (e.target.dataset.action === "close-filter-drawer") {
      this.closeFilterDrawer();
      return;
    }
  }

  outsideClickHandler(e) {
    if (window.innerWidth > 767) {
      if (!e.target.closest(".filter")) {
        this.resetDrawerState();
      }
    }
  }

  inputHandler(e) {
    if (!e.target.dataset.priceFilter) return;
    this.debounce(() => {
      this.applyPriceRange();
    }, 1000);
  }

  eventHandler(e) {
    const fragment = document.createElement("div");
    fragment.innerHTML = e.detail.filter_data;
    const filters = fragment.querySelectorAll("[data-filter]");
    filters.forEach((filter) => {
      const element = this.querySelector(
        `[data-filter="${filter.dataset.filter}"][value="${filter.value.replaceAll('"', '\\\"')}"]`,
      );
      const parent = element.parentElement;
      element.dataset.count = filter.dataset.count;
      filter.dataset.count <= 0
        ? parent.classList.add("filter-option--nocount")
        : parent.classList.remove("filter-option--nocount");
      filter.dataset.count <= 0
        ? parent.classList.remove("filter-option--hascount")
        : parent.classList.add("filter-option--hascount");
      element.nextElementSibling.querySelector(".filter-option__count").textContent =
        `(${filter.dataset.count})`;
    });
  }

  openFilterDrawer() {
    this.setAttribute("aria-expanded", "true");
  }

  closeFilterDrawer() {
    this.setAttribute("aria-expanded", "false");
    this.debounce(() => {
      this.resetDrawerState();
    });
  }

  checkPriceFilters(e) {
    if (!this.minPriceElem || !this.maxPriceElem) {
      return;
    }

    this.minPriceElem.value === "" ? (this.minPriceElem.value = this.minPrice) : null;
    this.maxPriceElem.value === "" ? (this.maxPriceElem.value = this.maxPrice) : null;

    const minElemValue = parseInt(this.minPriceElem.value);
    const maxElemValue = parseInt(this.maxPriceElem.value);

    minElemValue < this.minPrice ? (this.minPriceElem.value = this.minPrice) : null;
    minElemValue > this.maxPrice ? (this.minPriceElem.value = this.maxPrice) : null;
    maxElemValue < this.minPrice ? (this.maxPriceElem.value = this.minPrice) : null;
    maxElemValue > this.maxPrice ? (this.maxPriceElem.value = this.maxPrice) : null;

    minElemValue > maxElemValue ? (this.maxPriceElem.value = this.minPriceElem.value) : null;

    if (minElemValue === this.minPrice && maxElemValue === this.maxPrice) {
      this.minPriceElem.setAttribute("name", "");
      this.maxPriceElem.setAttribute("name", "");
    } else {
      this.minPriceElem.setAttribute("name", this.minPriceElem.dataset.priceFilter);
      this.maxPriceElem.setAttribute("name", this.maxPriceElem.dataset.priceFilter);
    }
    this.setRangeHandles();
  }

  setRangeHandles() {
    const event = new CustomEvent("range:set", {
      detail: {
        min: {
          current:
            this.minPriceElem.value !== "" ? parseInt(this.minPriceElem.value) : this.minPrice,
          limit: this.minPrice,
        },
        max: {
          current:
            this.maxPriceElem.value !== "" ? parseInt(this.maxPriceElem.value) : this.maxPrice,
          limit: this.maxPrice,
        },
      },
    });
    document.dispatchEvent(event);
  }

  updatePriceRange(e) {
    const { id, percentage } = e.detail;
    if (!this.querySelector(".filter-option--price")) return;

    const filter = this.querySelector(
      id === "range-slider-min"
        ? '.price__range-from input[type="number"]'
        : '.price__range-to input[type="number"]',
    );
    const maxValue = filter.getAttribute("max");

    filter.value = Math.round((percentage / 100) * maxValue);
  }

  applyPriceRange() {
    this.checkPriceFilters();
    this.changeFilter();
  }

  changeFilter() {
    const filtersForm = new FormData(this.querySelector("form"));
    const searchParamsArr = [];
    for (const [key, value] of filtersForm) {
      if (key.indexOf("filter") !== -1) {
        searchParamsArr.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    const searchParamsStr = searchParamsArr.join("&");
    // emit custom event with search string as payload
    const filterChangeEvent = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParamsStr,
        type: "filter",
      },
    });
    document.dispatchEvent(filterChangeEvent);
    this.updateActiveFilters(filtersForm);
  }

  createActiveFilterButton(filter) {
    const button = document.createElement("button");
    let attributes = {};
    let label = "";
    if (typeof filter[0] === "object") {
      // is price filter
      attributes = {
        "data-filter": "price",
        "data-active": "true",
        "aria-label": "Remove filter: Price range",
      };
      for (const priceGroup of filter) {
        if (priceGroup[0].indexOf("gte") !== -1) {
          attributes["data-filter-from"] = priceGroup[0];
          attributes["data-value-from"] = priceGroup[1];
        } else if (priceGroup[0].indexOf("lte") !== -1) {
          attributes["data-filter-to"] = priceGroup[0];
          attributes["data-value-to"] = priceGroup[1];
        }
      }
      label = `Price: ${theme.Currency.formatMoney(
        attributes["data-value-from"] * 100,
        theme.strings.moneyFormat,
      )} - ${theme.Currency.formatMoney(attributes["data-value-to"] * 100, theme.strings.moneyFormat)}`;
    } else {
      // is normal filter
      attributes = {
        "data-filter": filter[0],
        "data-value": filter[1],
        "data-active": "true",
        "aria-label": `Remove filter: ${decodeURIComponent(filter[2].replace(/\+/g, " "))}`,
      };
      label = decodeURIComponent(filter[2].replace(/\+/g, " "));
    }
    for (const key in attributes) {
      button.setAttribute(key, attributes[key]);
    }
    button.classList.add("active-filters__button");
    button.innerHTML = `${label}<span class="active-filters__cross" aria-hidden="true"></span>`;
    return button;
  }

  updateActiveFilters(filters = []) {
    const filter_count = this.querySelector("span.active__count");
    const buttons = document.createDocumentFragment();
    let count = 0;
    let priceFilter = [];
    for (const filter of filters) {
      if (filter[0].indexOf("filter") !== -1) {
        if (filter[0].indexOf("filter.v.price") !== -1) {
          filter[1] !== "" ? priceFilter.push(filter) : null;
        } else {
          count++;
          const data_label = this.querySelector(
            `[data-filter="${filter[0]}"][value="${filter[1].replaceAll('"', '\\\"')}"]`,
          )?.getAttribute("data-label");
          if (data_label) {
            filter.push(data_label);
          }
          const button = this.createActiveFilterButton(filter);
          buttons.appendChild(button);
        }
      }
    }
    if (priceFilter.length !== 0) {
      count++;
      const button = this.createActiveFilterButton(priceFilter);
      buttons.appendChild(button);
    }
    if (count > 0) {
      const clearButton = document.createElement("button");
      clearButton.classList.add("active-filters__clear");
      clearButton.setAttribute("data-clear", "true");
      clearButton.textContent = "Clear all";
      buttons.appendChild(clearButton);
      filter_count.innerHTML = `(${count})`;
    } else {
      this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
        filter.checked = false;
      });
      this.querySelectorAll(`[type="number"]`).forEach((filter) => {
        filter.value = null;
      });
      filter_count.innerHTML = "";
    }
    const activeFilters = this.querySelector(".active-filters");
    activeFilters.replaceChildren(buttons);
    this.querySelectorAll(".active-filters").forEach((container, index) => {
      if (index !== 0) {
        container.innerHTML = activeFilters.innerHTML;
      }
    });
  }

  resetDrawerState() {
    this.querySelectorAll(".filter__header").forEach((header) => {
      header.setAttribute("aria-expanded", "false");
    });
  }

  debounce(fn, wait = 300) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("results-filters", ResultsFilters);

class ResultsSorting extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("input", this.changeHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("input", this.changeHandler.bind(this));
  }

  changeHandler(e) {
    this.querySelector("label").dataset.activeSort = e.target.querySelector(
      `option[value="${e.target.value}"]`,
    ).innerHTML;
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: `sort_by=${e.target.value}`,
        type: "sort_by",
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("results-sorting", ResultsSorting);

class ProductCardMedia extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector(".product-card-media__container");
    this.images = this.querySelectorAll(".product-card-media__image");
    this.events = [
      {
        el: this.container,
        evt: "scrollend",
        callback: this.detectActiveMedia.bind(this),
      },
    ];
  }
  connectedCallback() {
    this.handleEventListeners();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }
  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }
  detectActiveMedia(e) {
    // Remove active dot class
    this.querySelector(".active-pagination-dot")?.classList.remove("active-pagination-dot");

    let closestIndex = null;
    let closestDistance = Infinity;

    for (const [index, image] of Object.entries(this.images)) {
      const distance = Math.abs(
        image.getBoundingClientRect().left - this.container.getBoundingClientRect().left,
      );
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    }

    if (closestIndex !== null) {
      const activeDot = this.querySelector(
        `.product-card-media__pagination-dot[data-index="${closestIndex}"]`,
      );
      activeDot?.classList.add("active-pagination-dot");
    }
  }
}
customElements.define("product-card-media", ProductCardMedia);

class QuickAddDrawerElement extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    this.drawer = this.querySelector("details");
    this.drawer_body = this.querySelector("[target-drawer-content]");
    this.main_button = this.querySelector("[action-open-drawer]");
    this.is_modal_drawer = this.drawer_body instanceof HTMLDialogElement;
    this.is_mobile_dialog = false;
    this.events = [
      {
        el: this,
        evt: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: document,
        evt: "click",
        callback: this.outsideClickHandler.bind(this),
      },
      {
        el: this,
        evt: "keydown",
        callback: this.keyboardHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.handleEventListeners();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
    if (this.is_mobile_dialog) {
      document.documentElement.classList.remove("quick-add-dialog-open");
    }
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  clickHandler(e) {
    if (e.target.closest("[action-open-drawer]")) {
      e.preventDefault();
      this.toggleMenu();
    }
    if (e.target.closest("[action-close-drawer]")) {
      this.setHidden();
    }
    if (e.target === this.drawer_body && this.is_mobile_dialog) {
      const bounds = this.drawer_body.getBoundingClientRect();
      const clickedOutside =
        e.clientX < bounds.left ||
        e.clientX > bounds.right ||
        e.clientY < bounds.top ||
        e.clientY > bounds.bottom;

      if (clickedOutside) this.setHidden();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest(".custom-drawer") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (!this.is_open) {
      this.setVisible();
    } else {
      this.setHidden();
    }
  }

  setHidden() {
    cancelAnimationFrame(this.open_animation_frame);
    this.is_open = false;
    this.main_button.setAttribute("aria-expanded", "false");
    this.classList.remove("drawer-open");
    onAnimationEnd(this.drawer_body, () => {
      if (!this.is_open) {
        if (this.is_modal_drawer) {
          if (this.drawer_body.open) this.drawer_body.close();
          document.documentElement.classList.remove("quick-add-dialog-open");
          this.is_mobile_dialog = false;
        }
        this.drawer.removeAttribute("open");
      }
    });
  }

  setVisible() {
    this.drawer.setAttribute("open", "");
    this.is_open = true;
    this.is_mobile_dialog =
      this.is_modal_drawer && window.matchMedia("(max-width: 767px)").matches;
    if (this.is_modal_drawer && !this.drawer_body.open) {
      if (this.is_mobile_dialog) {
        this.drawer_body.showModal();
        document.documentElement.classList.add("quick-add-dialog-open");
      } else {
        this.drawer_body.show();
      }
    }
    this.main_button.setAttribute("aria-expanded", "true");
    this.open_animation_frame = requestAnimationFrame(() => {
      this.classList.add("drawer-open");
    });
  }
}

customElements.define("quick-add-drawer-element", QuickAddDrawerElement);

class QuickAdd extends QuickAddDrawerElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.product_json = this.querySelector("[quick-add-data]")
      ? JSON.parse(this.querySelector("[quick-add-data]").innerHTML)
      : null;
    this.product_data = this.product_json?.product;
    this.events = [
      ...this.events,
      {
        evt: "submit",
        el: this.form,
        callback: this.submitHandler.bind(this),
      },
      {
        evt: "input",
        el: this.form,
        callback: this.changeHandler.bind(this),
      },
      {
        evt: "variant:change",
        el: this.closest("product-card"),
        callback: this.variantChangeHandler.bind(this),
      },
      {
        evt: "cart:add:success",
        el: document,
        callback: this.cartAddSuccessHandler.bind(this),
      },
    ];
  }
  setVisible() {
    super.setVisible();
    if (this.classList.contains("quick-add--compact")) return;
    this.querySelector("[action-close-drawer]").focus();
  }

  submitHandler(e) {
    e.preventDefault();
    this.addItemToCart(e);
  }

  changeHandler(e) {
    this.changeVariantSelect();
  }

  cartAddSuccessHandler(e) {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (e.detail?.source === this && this.is_open && isMobile) {
      this.setHidden();
    }
  }

  addItemToCart(e) {
    const data = new FormData(this.form);

    const line_properties = Array.from(data).filter((item) => {
      return item[0].includes("properties");
    });

    const properties = {};

    for (const property of line_properties) {
      const regex = /(?<=\[).*?(?=\])/g;
      const key = property[0].match(regex);
      properties[key] = property[1];
    }
    const options = {
      detail: {
        submitter: e.submitter,
        data: {
          items: [
            {
              id: +data.get("id"),
              quantity: +data.get("quantity"),
              properties,
            },
          ],
        },
      },
      bubbles: true,
    };

    const event = new CustomEvent("cart:add:submit", options);

    this.dispatchEvent(event);
  }

  changeVariantSelect(e) {
    if (!this.product_data) return;
    const data = new FormData(this.form);
    const selected = [];
    for (const [key, value] of data.entries()) {
      if (key.includes("quick-add__option")) {
        selected.push(value);
      }
    }

    const matching = this.product_data.variants.filter((variant) => {
      return variant.options.toString() === selected.toString();
    });

    this.updateSelectedProduct(matching);
    this.updateDisplayPrice(matching);

    const matched = matching[0];

    if (matched) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: {
            variantId: matched.id,
            variant: matched,
          },
        }),
      );
    }
  }

  updateSelectedProduct(variant) {
    const matched = variant[0];
    const submitter = this.form.querySelector('button[type="submit"]');
    const submitter_text = submitter.querySelector("span.btn-elem--text");

    if (variant.length <= 0) {
      submitter.classList.add("btn-style__nostock", "btn-style__unavailable");
      submitter_text.innerHTML = window.variantStrings.unavailable;
      return;
    } else {
      if (matched.available === false) {
        submitter.classList.add("btn-style__nostock");
        submitter_text.innerHTML = window.variantStrings.soldOut;
        return;
      } else {
        submitter.classList.remove("btn-style__nostock", "btn-style__unavailable");
        submitter_text.innerHTML = window.variantStrings.addToCart;
      }
      this.updateMasterSelect(matched.id);
    }
  }

  updateMasterSelect(id) {
    this.querySelector(".quick-add__master-select").value = id;
  }

  updateDisplayPrice(variant) {
    const matched = variant[0];
    if (variant.length <= 0) return;

    const price_containers = this.querySelectorAll(".quick-add__product-price");
    for (const price_elem of price_containers) {
      if (price_elem.closest(".btn-elem")) {
        price_elem.innerHTML = ` - ${theme.Currency.formatMoney(matched.price, theme.strings.moneyFormat)}`;
      } else {
        price_elem.innerHTML = theme.Currency.formatMoney(matched.price, theme.strings.moneyFormat);
      }
    }
  }

  variantChangeHandler(e) {
    const variantId = e.detail.variantId;

    const variant = this.product_data?.variants.find((variant) => variant.id === variantId);

    if (!variant) return;

    // Update the hidden master select
    this.updateMasterSelect(variantId);

    // Update the option dropdowns
    const selects = this.querySelectorAll('[name^="quick-add__option-select"]');

    selects.forEach((select, index) => {
      select.value = variant.options[index];
    });

    // Update button state / price
    this.updateSelectedProduct([variant]);
    this.updateDisplayPrice([variant]);
  }
}

customElements.define("quick-add", QuickAdd);

class VariantSwatches extends HTMLElement {
  constructor() {
    super();

    this.dragScrollThreshold = 5;
    this.isPointerDown = false;
    this.isDragging = false;
    this.shouldSuppressClick = false;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;

    this.events = [
      {
        el: this,
        event: "change",
        callback: this.changeHandler.bind(this),
      },
      {
        el: this.closest("product-card"),
        event: "variant:change",
        callback: this.variantChangeHandler.bind(this),
      },
      {
        el: this,
        event: "pointerdown",
        callback: this.pointerDownHandler.bind(this),
      },
      {
        el: this,
        event: "pointermove",
        callback: this.pointerMoveHandler.bind(this),
      },
      {
        el: this,
        event: "pointerup",
        callback: this.pointerUpHandler.bind(this),
      },
      {
        el: this,
        event: "pointercancel",
        callback: this.pointerUpHandler.bind(this),
      },
      {
        el: this,
        event: "pointerleave",
        callback: this.pointerLeaveHandler.bind(this),
      },
      {
        el: this,
        event: "lostpointercapture",
        callback: this.pointerUpHandler.bind(this),
      },
      {
        el: this,
        event: "click",
        callback: this.clickHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.handleEventListeners();
  }

  disconnectedCallback() {
    this.handleEventListeners("remove");
    this.resetDragScroll();
  }

  handleEventListeners(type = "add") {
    for (const evt of this.events) {
      if (!evt.el) continue;

      if (type === "add") {
        evt.el.addEventListener(evt.event, evt.callback);
      } else {
        evt.el.removeEventListener(evt.event, evt.callback);
      }
    }
  }

  get canDragScroll() {
    return this.scrollWidth > this.clientWidth;
  }

  pointerDownHandler(e) {
    if (!this.canDragScroll || e.pointerType !== "mouse" || e.button !== 0 || !e.isPrimary) {
      return;
    }

    this.isPointerDown = true;
    this.isDragging = false;
    this.shouldSuppressClick = false;
    this.dragStartX = e.clientX;
    this.dragStartScrollLeft = this.scrollLeft;
  }

  pointerMoveHandler(e) {
    if (!this.isPointerDown) return;

    const dragDistance = e.clientX - this.dragStartX;

    if (!this.isDragging && Math.abs(dragDistance) < this.dragScrollThreshold) {
      return;
    }

    this.isDragging = true;
    this.shouldSuppressClick = true;
    this.classList.add("is-dragging");

    if (!this.hasPointerCapture(e.pointerId)) {
      this.setPointerCapture(e.pointerId);
    }

    this.scrollLeft = this.dragStartScrollLeft - dragDistance;
    e.preventDefault();
  }

  pointerUpHandler(e) {
    if (!this.isPointerDown) return;

    this.resetDragScroll();

    if (this.hasPointerCapture(e.pointerId)) {
      this.releasePointerCapture(e.pointerId);
    }
  }

  pointerLeaveHandler() {
    if (!this.isPointerDown || this.isDragging) return;

    this.resetDragScroll();
  }

  resetDragScroll() {
    this.isPointerDown = false;
    this.isDragging = false;
    this.classList.remove("is-dragging");
  }

  clickHandler(e) {
    if (!this.shouldSuppressClick) return;

    e.preventDefault();
    e.stopPropagation();
    this.shouldSuppressClick = false;
  }

  changeHandler(e) {
    const input = e.target;

    if (!input.matches('input[type="radio"]')) return;

    const variantId = Number(input.value);

    this.dispatchEvent(
      new CustomEvent("variant:change", {
        bubbles: true,
        detail: {
          variantId,
        },
      }),
    );
  }

  variantChangeHandler(e) {
    const variantID = e.detail.variantId;
    const visibleSwatches = Array.from(
      this.querySelectorAll(
        'label.variant-swatch:not(.variant-swatch--hidden) input[type="radio"]',
      ),
    );

    let swatch = visibleSwatches.find((input) => {
      return input.value === String(variantID);
    });

    if (!swatch) {
      const colourOptionIndex = Number(this.dataset.colourOptionIndex);
      const colour = e.detail.variant?.options?.[colourOptionIndex];

      if (colour) {
        swatch = visibleSwatches.find((input) => {
          return input.dataset.colour === colour;
        });
      }
    }

    if (!swatch) return;

    if (!swatch.checked) {
      swatch.checked = true;
    }

    this.updateImage(swatch, this.getVariantImage(e.detail.variant));
    this.updateCardUrl(swatch, variantID);
  }

  getVariantImage(variant) {
    if (!variant) return null;

    if (typeof variant.featured_image === "string") {
      return variant.featured_image;
    }

    return variant.featured_image?.src || variant.image?.src || variant.image || null;
  }

  updateImage(input, imageSrc = null) {
    const card = this.closest("product-card");

    const primaryImage = card.querySelector(".product-card-media__primary img");
    const src = imageSrc || input.dataset.image;

    if (primaryImage && src) {
      primaryImage.src = src;
      primaryImage.removeAttribute("srcset");
    }

    card.querySelector(".product-card-media__secondary")?.classList.add("is-hidden");
  }

  updateCardUrl(input, variantId = input.value) {
    const card = this.closest("product-card");

    const links = card.querySelectorAll(".product-card__media-link");
    if (links) {
      links.forEach((link) => {
        link.href = `${link.href.split("?")[0]}?variant=${variantId}`;
      });
    }
  }
}

customElements.define("variant-swatches", VariantSwatches);

async function cartAddItem(e) {
  let event;
  const source = e.target;
  const submitter = e.detail.submitter;
  let submitter_html;

  if (submitter) {
    submitter.classList.add("btn-elem--loading");
    submitter_html = submitter.innerHTML;
  }

  try {
    const body = {
      items: [
        {
          id: e.detail.data.items[0].id,
          quantity: e.detail.data.items[0].quantity,
          properties: e.detail.data.items[0].properties || {},
        },
      ],
    };

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw new Error("Something went wrong");
    }

    const data = await res.json();

    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
      submitter.classList.add("btn-elem--success");
      submitter.innerHTML = `<span class="success-tick"></span> Added to bag`;
    }

    event = new CustomEvent("cart:add:success", {
      detail: {
        type: "success",
        data,
        source,
      },
    });

    document.dispatchEvent(
      new CustomEvent("cart:get", {
        detail: {
          data,
        },
      }),
    );
  } catch (error) {
    console.error(error);

    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
      submitter.classList.add("btn-elem--error");
      submitter.innerHTML = `Something went wrong`;
    }

    event = new CustomEvent("cart:add:error", {
      detail: {
        type: "error",
        error,
      },
    });
  } finally {
    if (submitter) {
      setTimeout(() => {
        submitter.classList.remove("btn-elem--success", "btn-elem--error");
        submitter.innerHTML = submitter_html;
      }, 2000);
    }

    document.dispatchEvent(event);
  }
}

async function getCart() {
  try {
    const res = await fetch("/cart.js");

    if (!res.ok) {
      throw new Error("[cart:get] - Something went wrong");
    }

    const data = await res.json();

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    T4SThemeSP.Drawer.opend(jQuery_T4NT("#t4s-mini_cart"));
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        detail: { data },
      }),
    );
  } catch (error) {
    console.error(error);
  }
}

document.addEventListener("cart:add:submit", cartAddItem);
document.addEventListener("cart:get", getCart);

function updatePricePerPair(event) {
  const variantPrice = Number(event.currentVariant?.price);
  const productContainer =
    event.target instanceof Element ? event.target.closest("[data-product-featured]") : null;
  const pricePerPairElement = productContainer?.querySelector(".product__price-per-pair");
  const priceValueElement = pricePerPairElement?.querySelector("[data-price-per-pair-value]");
  const quantityOptionElement = productContainer?.querySelector(
    ".main-product__variant-option--quantity[data-id]",
  );
  const quantityOptionIndex = Number(quantityOptionElement?.dataset.id);
  const quantityOptionValue = event.currentVariant?.options?.[quantityOptionIndex];
  const packQuantity = Number(String(quantityOptionValue ?? "").match(/\d+(?:\.\d+)?/)?.[0]);

  if (!pricePerPairElement || !priceValueElement || !Number.isFinite(variantPrice)) {
    return;
  }

  if (!Number.isFinite(packQuantity)) {
    return;
  }

  if (packQuantity <= 1) {
    pricePerPairElement.hidden = true;
    return;
  }

  const calculatedPricePerPair = Math.floor(variantPrice / packQuantity);

  pricePerPairElement.hidden = false;
  priceValueElement.innerHTML = T4SThemeSP.Currency.formatMoney(calculatedPricePerPair);
}

jQuery_T4NT(document).on("variant:changed", updatePricePerPair);

function updateProductSku(event) {
  const productContainer =
    event.target instanceof Element ? event.target.closest("[data-product-featured]") : null;
  const skuElement = productContainer?.querySelector(".product-sku");
  const skuValueElement = skuElement?.querySelector("span");

  if (!skuElement || !skuValueElement) {
    return;
  }

  const sku = event.currentVariant?.sku ?? "";

  skuValueElement.textContent = sku;
  skuElement.hidden = sku === "";
}

jQuery_T4NT(document).on("variant:changed", updateProductSku);

// FAQ Functionaility
const toggleFAQ = (e) => {
  var parentEl = e.target.classList.contains("mphus-faq__container")
    ? e.target
    : e.target.closest(".mphus-faq__container");
  var answerEl = parentEl.querySelector(".faq-answer");
  if (parentEl.classList.contains("q-active")) {
    parentEl.classList.remove("q-active");
    answerEl.style.height = "0px";
  } else {
    parentEl.classList.add("q-active");
    answerEl.style.height = answerEl.scrollHeight + "px";
  }
};

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        const recommendationsSection = this.closest(".product-recommendations-slider");
        const hasRecommendationProducts = recommendations?.querySelector(
          ".product-recommendations-slider__wrapper",
        );

        if (this.dataset.hideWhenEmpty === "true" && !hasRecommendationProducts) {
          recommendationsSection?.setAttribute("hidden", "");
          return;
        }

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
